import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { State, getProfile } from '@app/app.reducer';
import { ResetReducer as ResetReducerColorizerAction } from '@app/colorizer/colorizer.actions';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ColorizerService {
  styleLoadSubscription: Subscription[] = [];

  constructor(
    private http: HttpClient,
    private store: Store<State>
  ) {
    // each time user (admin is important for us) is logged out reset colorizer reducer
    this.store
      .select(getProfile)
      .pipe(skip(1))
      .subscribe((user) => {
        if (!user) {
          this.store.dispatch(new ResetReducerColorizerAction());
        }
      });
  }

  loadAllEventStyles() {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/style`);
  }

  loadEventStyle(styleId) {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/style/${styleId}`);
  }

  updateEventStyle(data, styleId) {
    return this.http.put(`${environment.protocol}${environment.webApiUrl}/style/${styleId}`, data);
  }

  createEventStyle(data) {
    return this.http.post(`${environment.protocol}${environment.webApiUrl}/style`, data);
  }

  saveEventStyles(data) {
    return this.http.post(`${environment.protocol}${environment.webApiUrl}/style/apply-style`, data);
  }

  saveOperatorStyles(data) {
    return this.http.put(`${environment.protocol}${environment.webApiUrl}/operator/styles`, data);
  }
}
